import React, {useState, useEffect} from "react";
import Header from "../Components/Header";
import { useNavigate } from "react-router-dom";
import Pagination from '@mui/material/Pagination';
import axios from "axios";
import WaChat from "./chat";
import { ReactSession } from 'react-client-session';
ReactSession.setStoreType("localStorage");


 function Wasend() {
    const navigate = useNavigate();
    const userId=ReactSession.get("welbeingId");
    const [input, setinput]=useState([]);
    const [error, setError] = useState("");
    const [Chat, setchat] = useState([]);
    const [Unreadchat, setUnread] = useState([]);
    console.log(Chat);


    if(userId  <= 0 ){
      navigate('/login');
   }


    const handleChange =(e) =>{
     const name= e.target.name;
     const value =e.target.value;
     setinput(values=>({...values, [name]:value}))

    }

    const handleSubmit = async(e) =>{
       e.preventDefault();

        const formdata = new FormData();
          formdata.append('key1', '91' + input.id);

     

        console.log(formdata);

       try{
        const response = await axios.post('https://api.welbeing.in/admin/whatsapp/chat/', formdata)
        console.log(response.data);
            
              navigate(`/wachat?id=91${input.id}`);
           
       }catch (err){
            setError(err.message);
       }
    }


    



    
    const fetch = async() =>{
        try{
            const response = await axios.get('https://api.welbeing.in/admin/whatsapp/new-message/');
            console.log(response.data);
            if(response.data.status==="Success"){
            
            setUnread(response.data.data);
            }else{
               console.error(response.data.error?.message);
            }
        }catch (err) {
             setError(err.message);
                
        }
    };




   
    const fetchchat = async() =>{
        try{
            const response = await axios.get('https://api.welbeing.in/admin/whatsapp/all-message/');
            console.log(response.data);
            if(response.data.status==="Success"){
            
            setchat(response.data.data);
            }else{
               console.error(response.data.error?.message);
            }
        }catch (err) {
             setError(err.message);
                
        }
    };


    useEffect(() => {
       fetch();
       fetchchat();
    }, []);




  return (

   <>

      <Header />
      <div class="page-wrapper" id="main-wrapper" data-layout="vertical" data-sidebartype="full" data-sidebar-position="fixed" data-header-position="fixed">
        <div class="body-wrapper">
          <div class="container-fluid">
            <div class="row">
              <div class="col-12 mb-md-0 mb-4">
                <div class="card">
                  <div class="card-header pb-0">
                    <div class="row">
                      <div class="col-lg-6 col-md-12 col-12">
                        <h6>Send Message</h6>
                        <p class="text-sm mb-0">
                        </p>
                      </div>

                    </div>
                  </div>
                  <div class="card-body px-0 pb-2">
                    <div class="card-body">
                      <form onSubmit={handleSubmit}>
                        <div class="mb-3">
                          <input type="text" class="form-control" name="id" placeholder="Enter Mobile Number without +91 &amp; 0" value={input.id} onChange={handleChange} />
                          <button type="submit" class="btn bg-gradient-dark  my-4 mb-2">Start New Chat</button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row my-4">
              <div class="container-1" id="modalbox" style={{ display: "flex" }}>
                <div class="col-12 mb-md-2 mb-4">
                  <div class="card">
                    <div class="card-header pb-0">
                      <div class="row">
                        <div class="col-lg-6 col-7">
                          <h6>Unread Messages <span id="unreadCount">{Unreadchat?.chatCount}</span></h6>
                        </div>

                      </div>
                    </div>
                    <div className="card-body px-2 pb-2">
                      <div className="table-responsive" style={{ overflowX: 'auto' }}>
                        <div className="card-body p-4">
                          <table className="table table-sm align-items-center border table-striped table-bordered mb-0 datatable"> {/* added table-sm */}
                            <thead>
                              <tr>
                                <th width="20%" className="p-3">Number</th>
                                <th colSpan="2" className="p-3">Message</th>
                                <th width="20%" className="p-3">Time</th>
                                <th width="15%" className="p-3">Options</th>
                              </tr>
                            </thead>
                            <tbody id="orderDetails">
                              {Array.isArray(Unreadchat?.chatDetails) && Unreadchat.chatDetails.map((chat) => (
                                chat.from_id ? (
                                  <tr key={chat.from_id}>
                                    <td className="align-middle text-sm p-3">
                                      <span className="text-xs font-weight-bold">{chat.from_id}</span>
                                    </td>
                                    <td className="align-middle text-sm p-3">
                                      <span className="text-xs font-weight-bold">{chat.last_message || 'No messages'}</span>
                                    </td>
                                    <td className="align-middle text-sm p-3">
                                      <span className="text-xs font-weight-bold">{chat.last_time || ''}</span>
                                    </td>
                                    <td className="align-middle text-sm p-3">
                                      {chat.unread_count > 0 ? (
                                        <span
                                          className="text-xs font-weight-bold"
                                          style={{
                                            background: 'red',
                                            color: '#fff',
                                            padding: '4px 8px',
                                            borderRadius: '50%'
                                          }}
                                        >
                                          {chat.unread_count}
                                        </span>
                                      ) : null}
                                    </td>
                                    <td className="align-middle text-sm p-3">
                                      <a
                                        href={`wachat?id=${chat.from_id}`}
                                        className="btn btn-success btn-sm py-1 px-2 mt-1 rounded-2"
                                      >
                                        Chat Now
                                      </a>
                                    </td>
                                  </tr>
                                ) : null
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row my-4">
              <div class="container-1" id="modalbox" style={{ display: "flex" }}>
                <div className="col-12 mb-md-0 mb-4">
                  <div className="card">
                    <div className="card-header pb-0">
                      <div className="row">
                        <div className="col-lg-6 col-7">
                          <h6>Chat List</h6>
                        </div>
                      </div>
                      <div className="card-body px-2 pb-2"> 
                        <div className="table-responsive" style={{ overflowX: 'auto' }}>
                          <div className="card-body p-2"> 
                            <table className="table table-sm align-items-center border table-striped table-bordered mb-0 datatable"> 
                              <thead>
                                <tr>
                                  <th width="20%" className="p-3">Number</th>
                                  <th colSpan="2" className="p-3">Message</th>
                                  <th width="20%" className="p-3">Time</th>
                                  <th width="15%" className="p-3">Options</th>
                                </tr>
                              </thead>
                              <tbody>
                                {Array.isArray(Chat?.chatDetails) && Chat.chatDetails.map((chat) =>
                                  chat.from_id ? (
                                    <tr key={chat.from_id}>
                                      <td className="text-sm p-1 text-right p-3">
                                        <span className="text-xs font-weight-bold">{chat.from_id}</span>
                                      </td>
                                      <td className="text-sm p-1 text-right p-3">
                                        <span className="text-xs font-weight-bold">{chat.last_message || 'No messages'}</span>
                                      </td>
                                      <td className="text-sm p-1 text-right p-3">
                                        <span className="text-xs font-weight-bold text-nowrap">{chat.last_time || ''}</span>
                                      </td>
                                      <td className="text-sm p-1 text-right p-3">
                                        {chat.unread_count > 0 && (
                                          <span
                                            className="text-xs font-weight-bold"
                                            style={{
                                              background: 'red',
                                              color: '#fff',
                                              padding: '4px 8px',
                                              borderRadius: '50%'
                                            }}
                                          >
                                            {chat.unread_count}
                                          </span>
                                        )}
                                      </td>
                                      <td className="text-sm p-1 text-right p-3">
                                        <a
                                          href={`wachat?id=${chat.from_id}`}
                                          className="btn btn-success btn-sm py-1 px-2 mt-1 rounded-2"
                                        >
                                          Chat Now
                                        </a>
                                      </td>
                                    </tr>
                                  ) : null
                                )}
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>





      </div>
    </>
  )
}
export default Wasend; 
